/**
 * Incorporation (Pre) — M32100 스튜디오 통합 필드 모듈.
 *   6문서(Section 14, Section 201(±attestation), CDD Individual/Legal Person/Legal Arrangement)를
 *   한 패널에서 편집. 필드 키 네임스페이스가 서로 겹치지 않으므로 키별로 기존 typeOf/labelize 에 위임.
 *     · CDD:            ind_ / lp_ / la_ / pt_ / bo_ / shareholder_ / share_type_ / share_pct_ / cdd_date / signer_designation
 *     · Incorporation:  company_ / dir<N>_ / mem<N>_ / director_ / member_ / business_ / registered_ / msic_ / …
 *   공유 키(signer_name / declaration_date)는 어느 쪽 typeOf 든 동일 결과.
 */
import type { CddFieldType } from '../cdd/cddFields';
import { typeOf as cddTypeOf, labelize as cddLabelize } from '../cdd/cddFields';
import { typeOf as incTypeOf, labelize as incLabelize } from '../incorporation/incorporationDocFields';

/** CDD 네임스페이스 키인가. */
export function isCddKey(key: string): boolean {
  return /^(ind|lp|la|pt|bo)_/.test(key)
    || /^shareholder_name_\d+$/.test(key)
    || /^share_(type|pct)_\d+$/.test(key)
    || /^bo_(name|relationship)_\d+$/.test(key)
    || key === 'cdd_date'
    || key === 'signer_designation';
}

export function typeOf(key: string): CddFieldType {
  // Section 201 인스턴스 필드: 이름은 person(✨ 사람조회), NRIC 는 text, 날짜는 date.
  if (key === 's201_name') return 'person';
  if (key === 's201_nric') return 'text';
  return isCddKey(key) ? cddTypeOf(key) : incTypeOf(key);
}

export function labelize(key: string): string {
  return isCddKey(key) ? cddLabelize(key) : incLabelize(key);
}
